<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{(isEdit ? 'action.edit' : 'action.create') | transloco}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>
<nz-skeleton [nzActive]="true" [nzLoading]="isLoading.model">
  <form nz-form class="hx-form" [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()" *transloco="let tr; prefix: 'workflows'; scope: 'workflows'">
    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.title')}}</nz-form-label>
          <nz-form-control>
            <hx-label-edit formControlName="title"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label>{{tr('form.description')}}</nz-form-label>
          <nz-form-control>
            <textarea rows="4" nz-input formControlName="description"></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.category')}}</nz-form-label>
          <nz-form-control>
            <hx-workflow-category-select formControlName="workflowCategoryId"></hx-workflow-category-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

      <div nz-row [nzGutter]="8" class="form-fieldset">
        <div nz-col class="form-fieldset-inner" *ngFor="let i = index; let cityStore of cityStores">
          <label style="font-weight: bold">{{cityStore.city.title | uiLabel}}</label>
          <div style="align-items: center">
            <nz-checkbox-wrapper style="width: 100%;">
              <div nz-row *ngFor="let store of cityStore.stores">
                <div nz-col nzSpan="1" *ngIf="store.active">
                  <label nz-checkbox [nzValue]="store.id" [ngModel]="storeIds.indexOf(store.id) >= 0"
                         [ngModelOptions]="{standalone: true}" (ngModelChange)="check(store.id)">{{store.title | uiLabel}}</label>
                </div>
              </div>
            </nz-checkbox-wrapper>
          </div>
        </div>
      </div>


    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

    <div nz-row [nzGutter]="8" class="cp_actions">
      <div nz-col>
        <nz-form-item>
          <nz-form-control>
            <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
              <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-tag nzColor="success" *ngIf="form.pristine && model.id">
          <i nz-icon nzType="check-circle"></i>
          <span>{{'form.saved' | transloco}}</span>
        </nz-tag>
      </div>
    </div>
  </form>
</nz-skeleton>
